/**
 * @param   {object}   state
 * @param   {number}   id
 *
 * @returns {Function}
 */
const getProjectById = state => id =>
  state.projects.find(project => project.id === id)

/**
 * @param   {object}   state
 * @param   {number}   groupId
 * @param   {number}   seasonId
 *
 * @returns {Function}
 */
const getProjectsByGroupIdAndSeasonId = state => (groupId, seasonId) =>
  state.projects.filter(project => {
    const projectGroupId = project.group ? project.group.id : null
    const projectSeasonId = project.season ? project.season.id : null

    if (projectGroupId && projectSeasonId) {
      return projectGroupId === groupId && projectSeasonId === seasonId
    } else {
      return false
    }
  })

/**
 * @type {object}
 */
const getters = {
  getProjectById,
  getProjectsByGroupIdAndSeasonId
}

export default getters
